// extracted by mini-css-extract-plugin
export default {"icon":"DeviceStat_icon__BS7JI"};